import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3abff282")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("svg", {
    class: _ctx.state.className,
    "aria-hidden": "true"
  }, [
    _createVNode("use", {
      "xlink:href": _ctx.state.name
    }, null, 8, ["xlink:href"])
  ], 2))
})